<template>
  <div id="CadUser" class="container row">
    <div class="col-md-6">
      <div class="card">    
        <div class="card-header">
          Lista de Pessoas <router-link class="btn btn-success" :to="{ name: 'AddPessoa' }" >Adicionar</router-link>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th scope="col">
                  </th>
                  <th scope="col">
                    Usuário 
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="us in usuarios" v-bind:key="us">
                  <td>
                    <a href="#" class="icon">
                      <i v-on:click="setShowModalConfirm('Deseja realmente excluir?', obj.id)" class="fa fa-trash"></i>
                    </a>
                  </td>
                  <td>
                    {{obj.tipo.descricao}}
                  </td>            
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <p class="alert alert-danger" v-if="errors.length">
        <span v-for="error in errors" v-bind:key="error">{{ error }}</span>
      </p>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Email</label>
          <input type="text" class="form-control form-control" v-model="email">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Nome</label>
          <input type="text" class="form-control form-control" v-model="nome">
        </div>
      </div>      
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Senha</label>
          <input type="password" class="form-control form-control" v-model="senha">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Confirma senha</label>
          <input type="password" class="form-control form-control" v-model="senha_confirma" >
        </div>
      </div>
      <div class="modal-footer">
        <slot name="footer">
          <button class="btn btn-primary" type="submit" v-on:click="signUp()" >Salvar</button>
          <!--<button class="btn btn-cancel" type="cancel" @click="closeModal($event)">Cancelar</button>-->
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
//const fb = require('../../config/db.js')

export default {
  name: 'CadUser',
  data(){
    return{
      email: '',
      nome: '',
      senha: '',
      senha_confirma: '',
      errors: [],
      usuarios: []
    }
  },
  methods: {
    signUp(){
      this.errors = [];
      if (!this.email)
        this.errors.push('Formato de email inválido');
      else if (this.email.search('@')<0)
        this.errors.push('Formato de email inválido');
      
      if (!this.senha)
        this.errors.push('Senha inválida');

      if (!this.nome)
        this.errors.push('Nome é obrigatório');
      
      if (this.senha != this.senha_confirma)
        this.errors.push('Senhas não conferem');
      
      if (this.errors.length)
        return;
      
      /*fb.auth.createUserWithEmailAndPassword(this.email, this.senha).then(
        (user) => {
          user.updateProfile({ displayName: this.nome }).then(
            uu => {
              alert("Criado com sucesso");
            });
        },
        error => {
          alert("Algum problema aconteceu!");
        });*/
    },

  }
}
</script>
